import React from 'react';

export const DetailBox = ({
  colCount,
  invoiceNo,
  colData,
  dataCompiler,
  value,
  setValue,
  clickHandler,
  showSave,
  dispatchData,
  isLoading,
  isBillCreationLoading
}) => {
  const data = dataCompiler( colData, dispatchData, isLoading, invoiceNo, isBillCreationLoading);
  return data ? (
    <>
      <div className="data-content">
        <div className="row">
          {Array.from({ length: colCount }).map((_, index) => (
            <div
              key={index}
              className={`${colCount === 1 ? 'col-xl-12 col-lg-12 col-12' : 'col-xl-6 col-lg-6 col-6'
                } mb-3`}>
              <div className="bg-white data-box w-100 h-100">
                {data.map((column) =>
                  column.col === 1 + index ? (
                    column.isCustom ? (
                      column.view({ value, setValue, clickHandler, showSave })
                    ) : (
                      <div key={column.name} className="row mb-3">
                        <div className={`${colCount === 1 ? 'col-2' : 'col-6'} title d-flex flex-wrap t-wrap`}>{column.name}</div>
                        <div className="col-6 d-flex flex-wrap t-wrap">
                          {typeof column?.data === 'string' ? (
                            column.data.length > 50 ? (
                              <span title={column.data}>{column.data.slice(0, 50) + '...'}</span>
                            ) : (
                              column.data
                            )
                          ) : (
                            column.data
                          )}
                        </div>
                      </div>
                    )
                  ) : null,
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  ) : null;
};
